export default __webpack_public_path__ + "static/media/arrow.7f69351d.svg";